import Header from "../components/Header";

import { useState, useEffect } from "react";
import "../styles/Quiz.css";

function Quiz() {
  // State setup
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [feedback, setFeedback] = useState("");
  const [extraInfo, setExtraInfo] = useState("");
  const [quizComplete, setQuizComplete] = useState(false);
  const [questions, setQuestions] = useState([]);

  //  Scores
  const [score, setScore] = useState(0);
  const [blockScores, setBlockScores] = useState({
    Europe: 0,
    UK: 0,
    USA: 0,
    World: 0,
  });

  const blocks = ["Europe", "UK", "USA", "World"];
  useEffect(() => {
  if (selectedBlock === null) return;

  const file = `/quiz/${selectedBlock.toLowerCase()}.json`;

  fetch(file)
    .then((res) => {
      if (!res.ok) throw new Error("Failed to load quiz JSON");
      return res.json();
    })
    .then((data) => {
      const formatted = data.map((row) => ({
        id: row.id,
        question: row.question,
        options: [
          row.option_a,
          row.option_b,
          row.option_c,
          row.option_d,
        ],
        answer: row.correct_answer,
        explanation: row.explanation,
      }));

         // shuffle properly
      const shuffled = [...formatted].sort(() => Math.random() - 0.5);

      // take only 5
      const limited = shuffled.slice(0, 5);

      console.log("LIMITED LENGTH:", limited.length);

      setQuestions(limited);
    })
    .catch((err) => console.error("Quiz load error:", err));
}, [selectedBlock]);

  // Function to handle block selection
  const selectBlock = (blockName) => {
    setSelectedBlock(blockName);
    setCurrentIndex(0);
    setSelectedOption("");
    setFeedback("");
    setExtraInfo("");
    setQuizComplete(false);
  };

  // Function to handle answer selection
  const handleAnswer = (option) => {
    setSelectedOption(option);
    const currentQuestion = questions[currentIndex];
    const isCorrect = option === currentQuestion.answer;
    setFeedback(
      isCorrect
        ? "Correct!"
        : `Wrong! Correct answer: ${currentQuestion.answer}`,
    );
    setExtraInfo(currentQuestion.explanation || "");
    // Update scores
    if (isCorrect) {
      setScore((prev) => prev + 1);
      setBlockScores((prev) => ({
        ...prev,
        [selectedBlock]: prev[selectedBlock] + 1,
      }));
    }
  };

  // Function to go to next question or finish quiz
  const nextQuestion = () => {
    if (currentIndex < questions.length - 1) {
      setCurrentIndex((prev) => prev + 1);
      setSelectedOption("");
      setFeedback("");
      setExtraInfo("");
    } else {
      setQuizComplete(true);
    }
  };

  // Function to reset quiz
  const resetQuiz = () => {
    setSelectedBlock(null);
    setCurrentIndex(0);
    setSelectedOption("");
    setFeedback("");
    setExtraInfo("");
    setQuizComplete(false);
  };

  // Function to handle back to topics with confirmation
  const handleBackToTopics = () => {
    if (window.confirm("Are you sure you want to go back to the topics?")) {
      resetQuiz();
    }
  };
console.log("QUESTIONS STATE:", questions);
console.log("CURRENT INDEX:", currentIndex);

  return (
    <>
      <Header />
      <div className="quiz-page">
        {!selectedBlock ? (
          <>
            <h1 className="quiz-title">Quiz</h1>
            <p className="quiz-subtitle">
              Which topic do you want to quiz yourself on?
            </p>
          </>
        ) : (
          <h1 className="quiz-title">{selectedBlock} Quiz</h1>
        )}

        {!selectedBlock && (
          <div className="block-selection">
            {blocks.map((block) => (
              <button
                key={block}
                className="block-button"
                onClick={() => selectBlock(block)}
              >
                {block}
              </button>
            ))}
          </div>
        )}

        {/* Score & Progress */}
        <div className="quiz-info">
          <p className="quiz-score">Score: {score} points</p>
          <div className="quiz-progress">
            <div
              className="quiz-progress-fill"
              style={{
                width: questions.length
  ? `${((currentIndex + 1) / questions.length) * 100}%`
  : "0%",
              }}
            ></div>
          </div>
        </div>

        {selectedBlock && !quizComplete && (
          <div className="quiz-card">
            <p className="question-count">
              Question {currentIndex + 1} of {questions.length}
            </p>

            {questions.length > 0 && questions[currentIndex] ? (
              <>
                <p className="quiz-question">
                  {questions[currentIndex].question}
                </p>

                <div className="quiz-options">
                  {questions[currentIndex].options?.map((option) => (
                    <button
                      key={option}
                      className="quiz-button"
                      onClick={() => handleAnswer(option)}
                      disabled={!!selectedOption}
                    >
                      {option}
                    </button>
                  ))}
                </div>
              </>
            ) : (
              <p>Loading questions...</p>
            )}

            {feedback && (
              <p
                className={`quiz-feedback ${
                  feedback.startsWith("Correct") ? "correct" : "wrong"
                }`}
              >
                {feedback}
              </p>
            )}
            {extraInfo && <p className="quiz-extra">{extraInfo}</p>}

            <div className="quiz-controls">
              {selectedOption && (
                <button className="next-button" onClick={nextQuestion}>
                  {currentIndex < questions.length - 1
                    ? "Next Question"
                    : "Finish Quiz"}
                </button>
              )}
              <button className="back-button" onClick={handleBackToTopics}>
                ⬅ Back to topics
              </button>
            </div>
          </div>
        )}

        {quizComplete && (
          <div className="quiz-complete">
            <p className="completion-title">
              🎉 You’ve completed the {selectedBlock} quiz!
            </p>
            <p className="block-score">
              Your score in this block: {blockScores[selectedBlock]} /{" "}
              {questions.length}
            </p>
            <p className="total-score">
              🏆 Total score: {score} points across all blocks
            </p>
            <button className="next-button" onClick={resetQuiz}>
              Back to topics
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default Quiz;
